/**
 * @ngdoc component
 * @name common.component.contact:contact-whatsapp
 * @description
 * Componente para mostrar la opción de contacto por Whatsapp en la sección contacto
 *
 */
(function () {
    'use strict';

    var ItxContactWhatsappCmp = {
        controller: ItxContactWhatsappCmpCtrl,
        templateUrl: 'contact-whatsapp.component.html',
        bindings: {
            config: '<',
            hours: '<'
        }
    };

    ItxContactWhatsappCmpCtrl.$inject = ['ItxScreenSizeSvc', 'crmService', 'ItxStaticResourceSvc', 'timestampSvc'];

    function ItxContactWhatsappCmpCtrl(ItxScreenSizeSvc, crmService, ItxStaticResourceSvc, timestampSvc) {
        var _this = this;
        _this.timeStamp = timestampSvc.getTs();
        _this.urlImg = ItxStaticResourceSvc.getImage('whatsappQR.png') + '?ts=' + _this.timeStamp;
        _this.isMobile = false;
        _this.is360 = false;

        _this.$onInit = function () {
            // Determinamos la resolución de pantalla
            _this.isMobile = ItxScreenSizeSvc.is('xs,sm');

            // Comprueba si el usuario actual está suscrito al programa Massimo Dutti Feel
            _this.is360 = crmService.is360();
        };
    }
    angular.module('itxApp.common').component('itxContactWhatsapp', ItxContactWhatsappCmp);
})();
